import React, { useState, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authService } from '../services/authService';
import './Login.css';

const Login = () => {
  const [formData, setFormData] = useState({
    ten_dang_nhap: '',
    mat_khau: ''
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    ten_dang_nhap: '',
    mat_khau: '',
    general: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // Load saved credentials on component mount
  useEffect(() => {
    const savedCredentials = localStorage.getItem('remembered_credentials');
    if (savedCredentials) {
      const { ten_dang_nhap, mat_khau } = JSON.parse(savedCredentials);
      setFormData({ ten_dang_nhap, mat_khau });
      setRememberMe(true);
    }
  }, []);

  // Nếu đã đăng nhập, chuyển hướng về trang chủ
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    // Clear error when user types
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: '',
        general: ''
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({ ten_dang_nhap: '', mat_khau: '', general: '' });

    // Validation
    const newErrors = {};
    if (!formData.ten_dang_nhap.trim()) {
      newErrors.ten_dang_nhap = 'Vui lòng nhập tên đăng nhập';
    }
    if (!formData.mat_khau) {
      newErrors.mat_khau = 'Vui lòng nhập mật khẩu';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors({ ...errors, ...newErrors });
      setLoading(false);
      return;
    }

    try {
      const response = await authService.login(formData);
      
      if (response.code === 200) {
        // Handle remember me functionality
        if (rememberMe) {
          localStorage.setItem('remembered_credentials', JSON.stringify({
            ten_dang_nhap: formData.ten_dang_nhap,
            mat_khau: formData.mat_khau
          }));
        } else {
          localStorage.removeItem('remembered_credentials');
        }
        
        login(response.data, response.data.access_token);
        navigate('/', { replace: true });
      } else {
        setErrors({ ...errors, general: response.message || 'Đăng nhập thất bại' });
      }
    } catch (error) {
      console.error('Login error:', error);
      const errorMessage = error.response?.data?.message || 'Có lỗi xảy ra khi đăng nhập. Vui lòng thử lại.';
      setErrors({ ...errors, general: errorMessage });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>AGS99 PNR Management</h1>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          {errors.general && (
            <div className="general-error-message">
              {errors.general}
            </div>
          )}
          
          <div className="form-group">
            <label htmlFor="ten_dang_nhap">Tên đăng nhập</label>
            <input
              type="text"
              id="ten_dang_nhap"
              name="ten_dang_nhap"
              value={formData.ten_dang_nhap}
              onChange={handleChange}
              placeholder="Nhập tên đăng nhập"
              disabled={loading}
              className={errors.ten_dang_nhap ? 'input-error' : ''}
            />
            {errors.ten_dang_nhap && (
              <div className="field-error">{errors.ten_dang_nhap}</div>
            )}
          </div>
          
          <div className="form-group">
            <label htmlFor="mat_khau">Mật khẩu</label>
            <div className="password-input-container">
              <input
                type={showPassword ? "text" : "password"}
                id="mat_khau"
                name="mat_khau"
                value={formData.mat_khau}
                onChange={handleChange}
                placeholder="Nhập mật khẩu"
                disabled={loading}
                className={errors.mat_khau ? 'input-error' : ''}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                disabled={loading}
              >
                <span className="password-icon">👁</span>
              </button>
            </div>
            {errors.mat_khau && (
              <div className="field-error">{errors.mat_khau}</div>
            )}
          </div>

          <div className="form-options d-flex justify-content-end">
            <label className="remember-me">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => {
                  setRememberMe(e.target.checked);
                  if (!e.target.checked) {
                    localStorage.removeItem('remembered_credentials');
                  }
                }}
                disabled={loading}
              />
              <span className="checkmark"></span>
              Nhớ mật khẩu
            </label>
          </div>
          
          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Đang đăng nhập...' : 'Đăng nhập'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;